import getBasePath from '../../../../common/functions/api-resource';

const basePath = getBasePath('planejamento_tatico', 'planejamento-tatico');

const planejamentoActions = {
  listar: { method: 'GET', url: `${basePath}?tamanhoPagina={size}&numeroPagina={page}&filtro={filter}` },
  autoComplete: { method: 'GET', url: `${basePath}?descricao={descricao}` },
  solicitante: { method: 'GET', url: `${basePath}/solicitante` },
  concluir: { method: 'POST', url: `${basePath}/fluxo` },
  copiar: { method: 'POST', url: `${basePath}/{id}/copia` },
  aprovar: { method: 'PUT', url: `${basePath}/aprovar` },
  reprovar: { method: 'PUT', url: `${basePath}/reprovar` },
  enviarParaAnalise: { method: 'PUT', url: `${basePath}/analise` },
  cancelar: { method: 'PUT', url: `${basePath}/cancelar` },
  executarAnalise: { method: 'PUT', url: `${basePath}/executar/analise` },
  gravar: { method: 'POST', url: basePath },
  obter: { method: 'GET', url: `${basePath}/{id}` },
  alterar: { method: 'PUT', url: `${basePath}/{id}` },
  listarAcoes: { method: 'GET', url: `${basePath}/{id}/acao-tatica/{entidade}/{idEntidade}` },
  validarTaxasDasAcoes: { method: 'GET', url: `${basePath}/{id}/acao-tatica/taxas` },
};

export default resource => resource(`${basePath}`, {}, planejamentoActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/planejamento-tatico.js